import React from "react";

const Contact: React.FC = () => {
  return (
    <section className="page-section text-flow">
      <p className="contact-name">Jiří Smolek</p>
      <p>
        Bojov 16
        <br/>
        Čisovice 252 10

      </p>
      <p></p>
      <p>
        Telefon: <a href="tel:+420774868657">+420 774 868 657</a>
        <br/>
        E-mail: <a href="mailto:info@truhlarstvismolek.cz">info@truhlarstvismolek.cz</a>
      </p>
      <p>IČO: 754 265 87</p>
      <iframe
        className="contact-map"
        style={{ border: "none" }}
        src="https://mapy.com/s/kozuvapake"
        width="600"
        height="480"
        frameBorder={0}
        title="Mapa provozovny"
      />
    </section>
  );
};

export default Contact;
